import FieldConfig from "../../../proto/field-config"
import FieldString from "../../../generic/string/string"
import {FIELD_CONDITIONS_NAME} from "../../../conditions/string"

export default class FieldExpenseName extends FieldString {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Expense name"

        this.conditionTypes     = FIELD_CONDITIONS_NAME
    }
}
